import { createFileRoute } from '@tanstack/react-router'

import { CheckinSignage } from '@/components/pages/Signage/CheckinSignage'

export const Route = createFileRoute('/e/$eventId/_display/signage/checkin')({
  component: CheckinSignage,
  staticData: {
    authRequired: false,
  },
})
